<!-- Overall Compliant -->
<div id="summary">
  <div class="overflow-x-auto mt-3 mb-5">
    <div class="border border-gray-200 rounded-lg overflow-hidden">

      <table class="w-full text-sm">

        <!-- Header -->
        <thead>
          <tr class="bg-blue-500 text-white">
            <th colspan="3" class="p-2 text-center font-bold tracking-wider">
              Assessment Rating
            </th>
          </tr>
        </thead>

        <!-- Result Row -->
        <tbody>
          <tr class="border-t border-gray-200">

            <!-- Score -->
            <td class="p-2 text-center font-bold border-r border-gray-200">
              {{ totalGraphicScore }}
            </td>

            <!-- Rating -->
            <td
              id="rating"
              class="p-2 text-center font-medium text-white"
              colspan="2"
              [style.backgroundColor]="rating?.color"
            >
              {{ rating?.name }}
            </td>

          </tr>
        </tbody>

      </table>

      <!-- Description -->
      <div class="mt-2 mb-2 text-sm text-gray-700">
        {{ rating?.description }}
      </div>

    </div>
  </div>

  <div class="hidden-summary hidden">

    <!-- Total of each Clauses -->
    @for (section of questions; track $index; let i = $index) {
      @if (section.title !== 'Summary') {

        <div class="flex justify-between items-center pt-4 mt-4">
          <h3 class="text-sm font-semibold text-blue-700">
            {{ section.title }}
          </h3>

          <div class="text-sm font-semibold text-gray-800">
            {{ getStepScore(i).percentage | number: '1.0-1' }}%
          </div>
        </div>

        <div class="w-full h-3 bg-gray-200 rounded-full mt-1">
          <div
            class="h-3 bg-blue-600 rounded-full transition-all"
            [style.width.%]="getStepScore(i).percentage"
          ></div>
        </div>

        <div class="overflow-x-auto mt-3">
          <table class="w-full text-sm border border-gray-200 rounded-lg">
            <thead class="bg-gray-100">
              <tr>
                <th class="p-2 text-left border-b">Answer Type</th>
                <th class="p-2 text-center border-b w-20">Yes</th>
                <th class="p-2 text-center border-b w-20">No</th>
                <th class="p-2 text-center border-b w-20">Partial</th>
                <th class="p-2 text-center border-b w-20">N/A</th>
                <th class="p-2 text-center border-b w-20">Total</th>
                <th class="p-2 text-center border-b w-24">Graphic Score</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td class="p-2 text-gray-700 font-medium">Counts</td>
                <td class="p-2 text-center">{{ getStepScore(i).yes }}</td>
                <td class="p-2 text-center">{{ getStepScore(i).no }}</td>
                <td class="p-2 text-center">{{ getStepScore(i).partial }}</td>
                <td class="p-2 text-center">{{ getStepScore(i).na }}</td>
                <td class="p-2 text-center">{{ getStepScore(i).total }}</td>
                <td class="p-2 text-center font-bold">{{ getStepScore(i).graphic }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      }
    }

    <!-- Total of All Clauses -->
    <div class="overflow-x-auto">
      <h3 class="text-sm font-semibold text-blue-700 pt-4 mt-4">All Clauses</h3>

      <table class="w-full text-sm border border-gray-200 rounded-lg">
        <thead class="bg-gray-100">
          <tr>
            <th class="p-2 text-left border-b">Answer Type</th>
            <th class="p-2 text-center border-b w-20">Yes</th>
            <th class="p-2 text-center border-b w-20">No</th>
            <th class="p-2 text-center border-b w-20">Partial</th>
            <th class="p-2 text-center border-b w-20">N/A</th>
            <th class="p-2 text-center border-b w-20">Total</th>
            <th class="p-2 text-center border-b w-24">Graphic Score</th>
          </tr>
        </thead>

        <tbody>
          <tr class="font-bold">
            <td class="p-2 text-gray-700">Counts</td>
            <td class="p-2 text-center">{{ getAllScoresTotal().yes }}</td>
            <td class="p-2 text-center">{{ getAllScoresTotal().no }}</td>
            <td class="p-2 text-center">{{ getAllScoresTotal().partial }}</td>
            <td class="p-2 text-center">{{ getAllScoresTotal().na }}</td>
            <td class="p-2 text-center">{{ getAllScoresTotal().total }}</td>
            <td class="p-2 text-center">{{ getAllScoresTotal().graphic }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Summary Table -->
    <div class="overflow-x-auto">
      <h3 class="text-sm font-semibold text-blue-700 pt-4 mt-4">Summary</h3>

      <table class="w-full text-sm border border-gray-200 rounded-lg">
        <thead class="bg-gray-100">
          <tr>
            <th class="p-2 text-left border-b">Clauses</th>
            <th class="p-2 text-center border-b w-24">Current Score</th>
            <th class="p-2 text-center border-b w-24">Target Score</th>
          </tr>
        </thead>

        <tbody>
          @for (section of questions; track $index; let i = $index) {
            @if (section.title !== 'Summary') {
              <tr>
                <td class="p-2 text-gray-700 font-medium">
                  {{ section.title }}
                </td>
                <td class="p-2 text-center">
                  {{ getStepScore(i).graphic }}
                </td>
                <td class="p-2 text-center">
                  {{ clampTarget(section.target) }}
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>

  <!-- Radar Chart -->
  <div class="radar-chart mt-6 border border-gray-200 rounded-lg p-5">
    <h3 class="text-lg font-semibold text-gray-800 mb-3">
      Your ISO 27001 Maturity Across Key Areas
    </h3>

    <canvas
      baseChart
      [data]="radarChartData"
      [labels]="radarChartLabels"
      [type]="'radar'"
      [options]="radarChartOptions"
      class="w-full h-80 bg-white"
    ></canvas>
  </div>

  <!-- Bar Chart -->
  <div class="bar-chart mt-6 border border-gray-200 rounded-lg p-5">
    <h3 class="text-lg font-semibold text-gray-800 mb-3">
      Your Readiness by ISO 27001 Domain
    </h3>

    <canvas
      class="bg-white"
      baseChart
      [data]="barChartData"
      [type]="'bar'"
      [options]="barChartOptions"
    ></canvas>
  </div>

</div>